import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import $ from 'jquery';
import {
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { showModal } from '../../actions';
import {
  updateUserSettings,
  setUserSetting,
} from '../../actions/Auth';
import {
  setCollectionsParams,
  setCollectionsLoading,
  clearCollectionsList,
} from '../../actions/Collections';
import {
  setFilesParams,
  setFilesReorderingMode,
} from '../../actions/Files';

import {
  isArchive,
  isMobile,
} from '../../helpers/App';
import {
  getCurrentUser,
  userCan,
  userHasCap,
} from '../../helpers/Auth';
import { getCollectionsView, getParentCollection } from '../../helpers/Collections';
import {
  eventSubscribe,
  eventUnsubscribe,
} from '../../helpers/Events';
import { addFlashMessage } from '../../helpers/FlashMessages';
import { getSetting } from '../../helpers/Settings';
import { goalSortSetting } from '../../helpers/Sort';

import SidebarFiltersSwitch from '../Sidebar/FiltersSwitch';
import UpgradePlanButton from '../UpgradePlanButton';
import SaveSort from '../Filters/SaveSort';

const moveButtons = () => {
  if (isMobile()) {
    const buttons = $('.header-actions.collections-actions');
    $('.filters-switch-wrapper').append(buttons);
  }
};

class CollectionsHeader extends PureComponent {
  constructor(props) {
    super(props);

    this.openAddCollectionModal = this.openAddCollectionModal.bind(this);
    this.afterCreateNewCollection = this.afterCreateNewCollection.bind(this);
    this.setReorderingMode = this.setReorderingMode.bind(this);
  }

  componentDidMount() {
    moveButtons();
    eventSubscribe('openAddCollectionModal', this.openAddCollectionModal);
  }

  componentWillUnmount() {
    eventUnsubscribe('openAddCollectionModal', this.openAddCollectionModal);
  }

  setOrder(orderby, order) {
    const {
      dispatch,
      refreshCollections,
    } = this.props;

    dispatch(setCollectionsParams({
      orderby,
      order,
      page: 0,
    }));
    dispatch(setFilesParams({
      orderby,
      order,
    }));
    refreshCollections(true);
  }

  setCollectionsView(view) {
    const {
      dispatch,
      refreshCollections,
    } = this.props;

    const profile = getCurrentUser();
    if (profile) {
      dispatch(clearCollectionsList());
      dispatch(setCollectionsLoading(true));
      dispatch(setUserSetting({ collections_view: view }));
      dispatch(updateUserSettings(profile.uuid, { collections_view: view })).then(() => {
        dispatch(setCollectionsParams({ page: 0 }));
        dispatch(setCollectionsLoading(false));
        refreshCollections(true);
      });
    }
  }

  setReorderingMode(status) {
    const { dispatch } = this.props;

    dispatch(setFilesReorderingMode(status));
  }

  getTitle() {
    const {
      intl,
      isAllCollections,
      isMyCollections,
    } = this.props;

    if (isAllCollections) {
      if (isArchive()) {
        return intl.formatMessage({ defaultMessage: 'All Collections (archive)' });
      }
      return intl.formatMessage({ defaultMessage: 'All Collections' });
    }
    if (isMyCollections) {
      if (isArchive()) {
        return intl.formatMessage({ defaultMessage: 'My Collections (archive)' });
      }
      return intl.formatMessage({ defaultMessage: 'My Collections' });
    }
    if (isArchive()) {
      return intl.formatMessage({ defaultMessage: 'All Collections (archive)' });
    }
    if (getSetting('cs1')) {
      return intl.formatMessage({ defaultMessage: 'Browse Categories' });
    }

    return intl.formatMessage({ defaultMessage: 'All Collections' });
  }

  openAddCollectionModal() {
    const {
      dispatch,
      isMyCollections,
    } = this.props;

    dispatch(showModal('CollectionEditModal', {
      className: 'modal-edit-collection',
      archived: isArchive(),
      parentCollection: isMyCollections ? { uuid: '-1' } : null,
      afterCreateCollection: this.afterCreateNewCollection,
    }));
  }

  afterCreateNewCollection(newCollection) {
    const {
      intl,
      dispatch,
      collection,
      refreshCollections,
    } = this.props;

    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({ defaultMessage: 'A new Collection has been created' }),
      button: {
        url: `/collections/${newCollection.uuid}`,
        text: intl.formatMessage({ defaultMessage: 'Open Collection' }),
      },
    });

    const parentCollection = getParentCollection(newCollection);
    if (
      (parentCollection && collection && collection.uuid === parentCollection.uuid) ||
      (!parentCollection && !collection) ||
      (parentCollection.uuid === '-1' && newCollection.my)
    ) {
      dispatch(setCollectionsParams({ page: 0 }));
      refreshCollections(true);
    }
  }

  render() {
    const {
      intl,
      collection,
      collections,
      collectionsTotal,
      isMyCollections,
      orderby,
      order,
      search,
      reorderingMode,
      loading,
    } = this.props;
    const collectionsView = getCollectionsView();
    const firstParent = collection?.ancestors[0];

    const goalSortSettingValue = goalSortSetting(orderby, order);

    return (
      <header className={classnames('page-header', { 'with-upgrade-button': isArchive() })}>
        <div className="filters-switch-wrapper">
          <SidebarFiltersSwitch />
        </div>
        <div className="page-header-left">
          <div className="page-header-title mb-0">
            <h2 className="page-title">
              {this.getTitle()}
              {isMyCollections && (
                <span className="page-subtitle ">
                  {intl.formatMessage({ defaultMessage: 'Your private Collections' })}
                </span>
              )}
            </h2>
          </div>
        </div>
        {isArchive() && (
          <UpgradePlanButton feature="archive" />
        )}
        <div className="header-actions collections-actions">
          <div className="collections-displaying">
            {(collectionsTotal > 0 && !loading) && (
              <span>
                {intl.formatMessage({
                  defaultMessage: '{collectionsLength} of {collectionsTotal} Collections',
                }, { collectionsLength: collections.length, collectionsTotal })}
              </span>
            )}
          </div>
          <div className="collections-actions-buttons">
            <SaveSort
              scope="collections"
              orderby={orderby}
              order={order}
              goalSortSettingValue={goalSortSettingValue}
            />
            <UncontrolledDropdown>
              <DropdownToggle
                id="CollectionsHeaderSort"
                className="transparent-button"
                size="sm"
                aria-label={intl.formatMessage({ defaultMessage: 'Sort' })}
              >
                <i className="fal fa-arrow-down-arrow-up" />
              </DropdownToggle>
              <UncontrolledTooltip target="CollectionsHeaderSort" fade={false} placement="top" boundariesElement="body">
                {intl.formatMessage({ defaultMessage: 'Sort' })}
                {goalSortSettingValue && (
                  <>
                    {': '}
                    {goalSortSettingValue.label}
                  </>
                )}
              </UncontrolledTooltip>
              <DropdownMenu>
                {search && (
                <DropdownItem
                  active={orderby === 'relevance'}
                  onClick={() => {
                    this.setOrder('relevance', 'asc');
                  }}
                >
                  {intl.formatMessage({ defaultMessage: 'Relevance' })}
                </DropdownItem>
                )}
                <DropdownItem
                  active={orderby === 'position'}
                  onClick={() => {
                    this.setOrder('position', 'asc');
                  }}
                >
                  {intl.formatMessage({ defaultMessage: 'Custom (re-ordered)' })}
                </DropdownItem>
                <DropdownItem
                  active={orderby === 'created_at' && order === 'desc'}
                  onClick={() => {
                    this.setOrder('created_at', 'desc');
                  }}
                >
                  {intl.formatMessage({ defaultMessage: 'Newest Collections' })}
                </DropdownItem>
                <DropdownItem
                  active={orderby === 'created_at' && order === 'asc'}
                  onClick={() => {
                    this.setOrder('created_at', 'asc');
                  }}
                >
                  {intl.formatMessage({ defaultMessage: 'Oldest Collections' })}
                </DropdownItem>
                <DropdownItem
                  active={orderby === 'updated_at' && order === 'desc'}
                  onClick={() => {
                    this.setOrder('updated_at', 'desc');
                  }}
                >
                  {intl.formatMessage({ defaultMessage: 'Recently updated' })}
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem
                  active={orderby === 'name' && order === 'asc'}
                  onClick={() => {
                    this.setOrder('name', 'asc');
                  }}
                >
                  {intl.formatMessage({ defaultMessage: 'A-Z' })}
                </DropdownItem>
                <DropdownItem
                  active={orderby === 'name' && order === 'desc'}
                  onClick={() => {
                    this.setOrder('name', 'desc');
                  }}
                >
                  {intl.formatMessage({ defaultMessage: 'Z-A' })}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown>
              <DropdownToggle
                id="CollectionsHeaderView"
                className="transparent-button"
                size="sm"
                aria-label={intl.formatMessage({ defaultMessage: 'View' })}
              >
                <i
                  className={classnames(
                    'fal',
                    collectionsView === 'grid' ? 'fa-grid' : '',
                    collectionsView === 'framed' ? 'fa-frame' : '',
                    collectionsView === 'list' ? 'fa-list' : '',
                  )}
                />
              </DropdownToggle>
              <UncontrolledTooltip target="CollectionsHeaderView" fade={false} placement="top" boundariesElement="body">
                {intl.formatMessage({ defaultMessage: 'View' })}
              </UncontrolledTooltip>
              <DropdownMenu>
                <DropdownItem
                  active={collectionsView === 'grid'}
                  onClick={() => {
                    this.setCollectionsView('grid');
                  }}
                >
                  <i className="fal fa-grid" />
                  {intl.formatMessage({ defaultMessage: 'Grid' })}
                </DropdownItem>
                <DropdownItem
                  active={collectionsView === 'framed'}
                  onClick={() => {
                    this.setCollectionsView('framed');
                  }}
                >
                  <i className="fal fa-frame" />
                  {intl.formatMessage({ defaultMessage: 'Framed' })}
                </DropdownItem>
                <DropdownItem
                  active={collectionsView === 'list'}
                  onClick={() => {
                    this.setCollectionsView('list');
                  }}
                >
                  <i className="fal fa-list" />
                  {intl.formatMessage({ defaultMessage: 'List' })}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            {(userCan('collection.reorder') && !isMyCollections) && (
              <div className="button-wrapper">
                <Button
                  id="reorderButton"
                  className={classnames('transparent-button', { 'transparent-button-primary': reorderingMode })}
                  size="sm"
                  onClick={(e) => {
                    e.preventDefault();
                    if (!(collectionsView === 'masonry' || collectionsView === 'tile')) {
                      this.setReorderingMode(!reorderingMode);
                    }
                  }}
                  aria-label={intl.formatMessage({ defaultMessage: 'Reorder' })}
                >
                  <i className="fal fa-arrows" />
                  {reorderingMode && <span>{intl.formatMessage({ defaultMessage: 'Finish Reordering' })} </span>}
                </Button>
                {(collectionsView === 'masonry' || collectionsView === 'tile') && (
                  <UncontrolledTooltip target="reorderButton" fade={false} placement="top" boundariesElement="body">
                    {intl.formatMessage({ defaultMessage: 'Switch to grid or list view to reorder files.' })}
                  </UncontrolledTooltip>
                )}
                {(!(collectionsView === 'masonry' || collectionsView === 'tile') && !reorderingMode) && (
                  <UncontrolledTooltip target="reorderButton" fade={false} placement="top" boundariesElement="body">
                    {intl.formatMessage({ defaultMessage: 'Reorder' })}
                  </UncontrolledTooltip>
                )}
              </div>
            )}
          </div>
          {(
            (!isArchive() || isMyCollections) &&
            (
              userHasCap('create_collection_all') ||
              (
                userHasCap('my_collections') &&
                (
                  (
                    firstParent &&
                    firstParent.uuid === '-1'
                  ) || isMyCollections
                )
              )
            )
          ) && (
            <div className="button-wrapper">
              <Button color="primary" onClick={() => { this.openAddCollectionModal(); }}>
                <i className="fas fa-plus" />
                <span>
                  {intl.formatMessage({ defaultMessage: 'New Collection' })}
                </span>
              </Button>
            </div>
          )}
        </div>
      </header>
    );
  }
}

const mapStateToProps = state => ({
  collection: state.Collections.collection,
  collections: state.Collections.collections,
  collectionsTotal: state.Collections.collectionsTotal,
  orderby: state.Collections.params.orderby,
  order: state.Collections.params.order,
  search: state.Search.search,
  reorderingMode: state.Files.reorderingMode,
});

CollectionsHeader.propTypes = {
  intl: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  collection: PropTypes.object,
  collections: PropTypes.array.isRequired,
  collectionsTotal: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  refreshCollections: PropTypes.func.isRequired,
  orderby: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  search: PropTypes.string,
  reorderingMode: PropTypes.bool.isRequired,
  isAllCollections: PropTypes.bool.isRequired,
  isMyCollections: PropTypes.bool.isRequired,
};

CollectionsHeader.defaultProps = {
  collection: null,
  search: null,
};

export default injectIntl(connect(mapStateToProps)(CollectionsHeader));
